export class InitError {
    // special use case: Being offline causes an error, but can be handled
    public isOfflineError = false;
    public isAuthenticationError = false;
    public isDateTimeError = false;
    public constructor(
        public originalError: Error,
        public hardFail = false,
    ) {}

    public toString(): string {
        return `InitError: originalError: ${JSON.stringify(this.originalError)}; forceHardFail: ${
            this.hardFail
        }; isOfflineError: ${this.isOfflineError}; isAuthenticationError: ${
            this.isAuthenticationError
        }; isDateTimeError: ${this.isDateTimeError}`;
    }
}
